import React from "react"
import styled from "@emotion/styled"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Container from "../components/container"

import {
  Box,
  Input,
  Button,
  Textarea,
  Heading,
  FormLabel,
  FormControl,
  Checkbox, CheckboxGroup,
} from "@chakra-ui/core"

import theme from "../theme"

const Styles = styled.div`
`

export default class extends React.Component {
  render() {
    return (
      <Layout >
        <SEO title="Contact" />
        <Styles>
              
            
          <Box bg="gray.100">
          <Container>
            <Heading >Contact</Heading>
            <Heading size="md" color="gray.900" textAlign={["center", "left"]} fontWeight="400" mb={4}>We'll get back to you shortly.</Heading>
            <Box rounded="md" p={"14px 20px"} maxWidth="540px" color="gray.800" bg="gray.200" mb={6}>
            <form name="contact" method="POST" action="/" data-netlify="true">
              <input type="hidden" name="form-name" value="contact" />
             

              <FormControl isRequired>
              <FormLabel>Email</FormLabel>
              <Input
                mb={2}
                color="gray.900"
                bg={ theme.white }
                type="email"
                name="email"
                required
              />
              </FormControl>

              <FormControl isRequired>
              <FormLabel>Subject</FormLabel>
              <Input
                mb={2}
                color="gray.900"
                bg={ theme.white }
                name="name"
                required
              />
              </FormControl>



              <FormControl isRequired>
              <FormLabel>Message</FormLabel>
              <Textarea color="gray.900" bg={ theme.white } mb={2} name="message" required />
              </FormControl>

              <FormControl mb={3}>
              <FormLabel>File</FormLabel>
                <div>
                <input type="file" name="file" />
                </div>
                </FormControl>
              <Button width="100px" variantColor="green" fontWeight="400" type="submit">
                Send{" "}
              </Button>
            </form>
            </Box>
          </Container>
          </Box>
        </Styles>
      </Layout>
    )
  }
}



// export const query = graphql`
//   {
    

   

    
//   }
// `